import type { PropertiesTableProps } from '../../../../shared/types'

export const WizardEditButtonProperties: PropertiesTableProps = {
  toStep: {
    doc: 'Lets you navigate to a specific step.',
    type: 'number',
    status: 'optional',
  },
}
